import React from "react";
import PolicyLayout, { Section, PolicyList } from "../../components/storefront/PolicyLayout";

export default function TermsConditions() {
  return (
    <PolicyLayout
      testid="terms-conditions-page"
      heading="Terms & Conditions"
      title="Terms & Conditions | Lecis Auto Glass"
      description="The terms governing use of the Lecis Auto Glass website and purchases — product and pricing disclaimers, limitation of liability, intellectual property and governing law."
      canonicalPath="/terms-conditions"
      updated="June 2026"
    >
      <Section>
        <p>
          These Terms &amp; Conditions ("Terms") govern your access to and use of the Lecis Auto Glass website
          and your purchase of products from us. By using this website or placing an order, you agree to these
          Terms.
        </p>
      </Section>

      <Section title="Website Usage">
        <PolicyList
          items={[
            "You agree to use this website for lawful purposes only and not to interfere with its operation or security.",
            "You are responsible for the accuracy of the information you provide, including shipping and fitment details.",
            "We may update, suspend, or discontinue any part of the website at any time without notice.",
          ]}
        />
      </Section>

      <Section title="Product Information Disclaimer">
        <p>
          We work to describe our products — including side mirrors, windshields and backglass — as accurately
          as possible, including fitment, features and images. However, descriptions may contain errors and
          product appearance may vary. Fitment guidance is provided as a convenience; you are responsible for
          confirming compatibility with your specific vehicle (year, make, model and trim) before ordering. We
          encourage you to use our Contact &amp; Fitment Help before purchase.
        </p>
      </Section>

      <Section title="Pricing Disclaimer">
        <PolicyList
          items={[
            "All prices are listed in U.S. dollars and are subject to change without notice.",
            "We reserve the right to correct pricing errors and to cancel orders placed with an incorrect price, even after an order is confirmed.",
            "Applicable taxes and shipping charges are calculated at checkout.",
            "Promotions, coupons and volume pricing are subject to their own terms and may be modified or withdrawn at any time.",
          ]}
        />
      </Section>

      <Section title="Orders & Acceptance">
        <p>
          Your order is an offer to purchase. We reserve the right to accept or decline any order, limit
          quantities, or cancel an order due to product availability, suspected fraud, or errors in product or
          pricing information. Where an order is cancelled by us, we will issue a refund per our Refund Policy.
        </p>
      </Section>

      <Section title="Limitation of Liability">
        <p>
          To the fullest extent permitted by law, Lecis Auto Glass is not liable for any indirect, incidental,
          special or consequential damages arising from the use of our website or products, including but not
          limited to installation costs, labor, calibration, or vehicle downtime. Our total liability for any
          claim shall not exceed the amount you paid for the product giving rise to the claim. Products should
          be installed by a qualified professional.
        </p>
      </Section>

      <Section title="Intellectual Property">
        <p>
          All content on this website — including logos, text, graphics, images, and page design — is the
          property of Lecis Auto Glass or its licensors and is protected by intellectual property laws. You may
          not copy, reproduce, or use our content without prior written permission. Third-party brand and
          vehicle names are used for descriptive/fitment reference only and remain the property of their
          respective owners; their use does not imply affiliation or endorsement.
        </p>
      </Section>

      <Section title="Governing Law">
        <p>
          These Terms are governed by the laws of the State of California, United States, without regard to its
          conflict-of-law principles. Any disputes arising under these Terms shall be subject to the exclusive
          jurisdiction of the state and federal courts located in California.
        </p>
      </Section>

      <Section title="SMS Terms">
        <p>You can contact Lecis Auto Glass by calling or texting (888) 785-1288.</p>
        <p>
          By texting Lecis Auto Glass, you agree to receive conversational text messages regarding your
          inquiry, appointment, order, or account.
        </p>
        <PolicyList
          items={[
            "Message frequency may vary.",
            "Message and data rates may apply.",
            "Reply STOP to opt out at any time.",
            "Reply HELP for assistance.",
            "Your mobile number will not be shared with third parties for marketing or promotional purposes.",
          ]}
        />
      </Section>

      <Section title="Changes to These Terms">
        <p>
          We may update these Terms from time to time. Changes are effective when posted to this page. Your
          continued use of the website after changes are posted constitutes acceptance of the updated Terms.
        </p>
      </Section>
    </PolicyLayout>
  );
}
